export default __webpack_public_path__ + "static/media/Illustration3.f98a9bce.png";